"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemberItem = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const utils_1 = require("../../../util/utils");
const SubscriptionAvatar_1 = require("../../../util/Avatar/SubscriptionAvatar");
const Actors_1 = require("../types/Actors");
const MemberItem = (props) => {
    const { actor, idType, removeSubscriber, disabled = false, displayName = true, className } = props;
    const { id, thumbnailUrl, name, avatarType, email } = (0, Actors_1.generateActorInfo)(idType, actor);
    const avatar = thumbnailUrl || name || '';
    return ((0, jsx_runtime_1.jsx)(SubscriptionAvatar_1.SubscriptionAvatar, { "data-testid": avatarType, avatar: avatar, avatarType: avatarType, onClick: removeSubscriber ? () => removeSubscriber(id, idType) : () => ({}), disabled: disabled, hoverText: displayName ? email : name, subscriberName: name, displayName: displayName, className: className, avatarUserType: (0, utils_1.isShipUserID)(id) ? 'customer' : 'fortie' }));
};
exports.MemberItem = MemberItem;
//# sourceMappingURL=MemberItem.js.map